import { useQuery } from '@tanstack/react-query';
import { getValidationReport } from 'src/api/getValidationReport';
import { QueryKeys } from 'src/hooks/QueryKeys';

export const useValidationReport = (reportId: string | null) =>
  useQuery({
    queryKey: [QueryKeys.validationReport, reportId],
    queryFn: () => getValidationReport(reportId ?? ''),
    enabled: !!reportId,
  });
